(function() {
  'use strict';

  // Fix the issue of ui-select dropdown not opening on clicking the caret icon
  // This issue arises only in case search-enabled="false"
  angular.module('ringbaPortal').directive('searchEnabled', searchEnabled);

  function searchEnabled () {
    const directive = {
      require: 'uiSelect',
      restrict: 'A',
      priority: 100,
      link: link
    };
    return directive;

    function link($scope, element) {
      $(element).on('click', '.ui-select-toggle > i.caret', function(e) {
        e.stopPropagation();

        const parent = $(this).parent('.ui-select-toggle');
        if(parent){
          parent.click();
        }
      });
    }
  }
})();
